'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.default = addJsCss;

var _aphrodite = require('aphrodite');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addJsCss(styles) {
  var keys = (0, _keys2.default)(styles);

  if (process.env.NODE_ENV === 'development' && (0, _typeof3.default)(styles[keys[0]]) !== 'object') {
    console.warn('Detected empty object passed to themed component... This might not be intentional.');
    return {};
  }

  var stylesheet = _aphrodite.StyleSheet.create(styles);

  return keys.reduce(function (acc, style) {
    acc[style] = (0, _aphrodite.css)(stylesheet[style]); // eslint-disable-line
    return acc;
  }, {});
}